export default "__VITE_ASSET__a8e97b17__"